module.exports = __webpack_public_path__ + "media/amex.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/amex.png
// module id = 45
// module chunks = 0